import React, { useState,useEffect } from "react";
import { RecordProvider } from "./context/RecordContext";
import Introduction from "./component/Introduction";
import DecisionPoint from "./component/DecisionPoint";
import Feedback from "./component/Feedback";
import "./App.css";
import ProductCarousel from "./cardslider/CardSlider";
import SupportPage from "./help&support/SupportPage";
import { Layout,Button } from "antd";
import AppHeader from "./defultpage/Header";
import Sidebar from "./defultpage/Sidebar";
import Banner from "./defultpage/Banner";
import Home from "./defultpage/Home";
import HelpSupport from "./help&support/ChatIcon";
import FilterComponent from "./defultpage/FilterComponent";
import ClienteleSection from "./defultpage/ClientSection";
import ComplaintModal from "./defultpage/ClientSection";
const { Content } = Layout;

const App = () => {
  const [started, setStarted] = useState(false);
  const [open, setOpen] = useState(false);

  // Open modal on first render
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    // <RecordProvider>
    //   <div className="app">
    //     {!started ? (
    //       <Introduction onStart={() => setStarted(true)} />
    //     ) : (
    //       <>
    //         <DecisionPoint />
    //         <Feedback />
    //       </>
    //     )}
    //   </div>
    // </RecordProvider>
    <>
      {/* <ProductCarousel/> */}
      {/* <SupportPage/> */}

      <Layout>
        {/* <Button variant="contained" onClick={() => setOpen(true)}>
          Open Modal
        </Button> */}
        <ComplaintModal open={open} handleClose={() => setOpen(false)} />
        {/* <FilterComponent/> */}
        {/* <AppHeader /> */}
        {/* <Layout>
        <Sidebar />
        <Content style={{ padding: "20px" }}>
          <Banner />
          <Home />
        </Content>
      </Layout> */}
        {/* <HelpSupport /> */}
      </Layout>
    </>
  );
};

export default App;

// import React, { useState, useEffect } from "react";
// import "./App.css";

// function App() {
//   const [fontSize, setFontSize] = useState(16);
//   const [themeColor, setThemeColor] = useState("#428bca");
//   const [darkMode, setDarkMode] = useState(false);

//   useEffect(() => {
//     document.documentElement.style.setProperty("--theme-color", themeColor);
//     document.documentElement.style.setProperty("--font-size", `${fontSize}px`);
//     document.body.className = darkMode ? "dark-mode" : "";
//   }, [themeColor, fontSize, darkMode]);

//   const increaseFontSize = () => {
//     setFontSize((prev) => Math.min(prev + 2, 28));
//   };

//   const decreaseFontSize = () => {
//     setFontSize((prev) => Math.max(prev - 2, 12));
//   };

//   return (
//     <div className="app-container">
//       {/* Navbar */}
//       <header className="navbar">
//         <h2 style={{ color: "#fff" }}>My Custom Page</h2>

//         <div className="navbar-controls">
//           {/* Font Buttons */}
//           <button onClick={decreaseFontSize} className="nav-btn">-A</button>
//           <button onClick={increaseFontSize} className="nav-btn">+A</button>

//           {/* Color Picker */}
//           <input
//             type="color"
//             value={themeColor}
//             onChange={(e) => setThemeColor(e.target.value)}
//             className="color-picker"
//             title="Pick a theme color"
//           />

//           {/* Dark Mode Toggle */}
//           <button
//             onClick={() => setDarkMode((prev) => !prev)}
//             className="nav-btn"
//           >
//             {darkMode ? "Light Mode" : "Dark Mode"}
//           </button>
//         </div>
//       </header>

//       {/* Page Content */}
//       <main className="content">
//         <h1>Welcome to the Demo Page</h1>
//         <p>This is a simple page where you can:</p>
//         <ul>
//           <li>Change font size</li>
//           <li>Pick a new theme color</li>
//           <li>Toggle dark/light mode</li>
//         </ul>
//       </main>
//     </div>
//   );
// }

// export default App;
